<div class="container">
  <div class="row eb-cards mt-4">
    <div class="col-xl-4"></div>
    <div class="col-xl-4">
      <div class="border-0 card login-info p-5 pl-lg-4 pr-lg-4 pt-lg-4 pb-lg-4">
        <div>
          <h3 class="font-weight-bold text-lg-left">Recover Username</h3>
        </div>
        <div class="align-items-baseline mx-0 row">
          <div class="col-lg-12 text-lg-left pl-lg-0 reset-pwd">
            <p class="font-weight-normal mt-lg-2">Just a few quick details and we’ll email your username right over!</p>
          </div>
        </div>
        <input
          type="text"
          aria-label="First Name"
          placeholder="First Name"
          id="firstName"
          name="firstName"
          class="form-control mt-3 mt-lg-0 input-height" />
        <!--<div class="row ml-1 error" *ngIf="(userNameRecoverForm.get('userName')?.touched && userNameRecoverForm.get('userName')?.errors)">
          {{userNameRecoverForm.get('userName')?.errors}}
        </div>-->
        <input
          type="text"
          aria-label="Last Name"
          placeholder="Last Name"
          id="lastName"
          name="lastName"
          class="form-control mt-3 mt-lg-3 input-height" />
        <!--<div class="row ml-1 error" *ngIf="(userNameRecoverForm.get('userName')?.touched && userNameRecoverForm.get('userName')?.errors)">
          {{userNameRecoverForm.get('userName')?.errors}}
        </div>-->
        <input
          type="text"
          aria-label="Company ID"
          placeholder="Company ID"
          id="companyId"
          name="companyId"
          class="form-control mt-3 mt-lg-3 input-height" />
        <!--<div class="row ml-1 error" *ngIf="(userNameRecoverForm.get('userName')?.touched && userNameRecoverForm.get('userName')?.errors)">
          {{userNameRecoverForm.get('userName')?.errors}}
        </div>-->
        <input
          type="text"
          aria-label="Zip Code"
          placeholder="Zip Code"
          id="zipCode"
          name="zipCode"
          class="form-control mt-3 mt-lg-3 input-height" />
        <!--<div class="row ml-1 error" *ngIf="(userNameRecoverForm.get('userName')?.touched && userNameRecoverForm.get('userName')?.errors)">
          {{userNameRecoverForm.get('userName')?.errors}}
        </div>-->
        <div class="align-items-center mt-3 mx-0 row">
          <div class="col-xl-9 pr-0 text-lg-right">
            <!-- <button id="linkBack" name="linkBack" class="btn btn-secondary d-inline font-12 pe-4 ps-4 text-black" [routerLink]="'/login'"> Back
            </button> -->
          </div>
          <div class="col-xl-3 pl-lg-0 pr-0 text-lg-right">
            <button
              aria-label="submit"
              class="bold btn btn-primary d-inline font-12 text-center w-auto"
              (click)="navigateToDashboard(this.userNameRecoverForm.getRawValue())">
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="col-xl-4"></div>
  </div>
</div>
